import { type AppState } from '../../types';
import type { ParsedInstance } from './parse-instance';

const getInstanceValues = (state: AppState) => state.instanceValues;

export function getInstanceValue<K extends keyof ParsedInstance>(
  state: AppState,
  key: K,
  fallback: ParsedInstance[K],
): ParsedInstance[K];
export function getInstanceValue<K extends keyof ParsedInstance>(
  state: AppState,
  key: K,
): ParsedInstance[K] | undefined;
export function getInstanceValue<K extends keyof ParsedInstance>(
  state: AppState,
  key: K,
  fallback?: ParsedInstance[K],
): ParsedInstance[K] | undefined {
  return getInstanceValues(state)?.[key] ?? fallback;
}

export const getIsDemoMode = (state: AppState) => getInstanceValue(state, 'demoMode');
export const getBiToken = (state: AppState) => getInstanceValue(state, 'biToken');
export const getMetaSiteId = (state: AppState) => getInstanceValue(state, 'metaSiteId');
export const getSiteIsTemplate = (state: AppState) => getInstanceValue(state, 'siteIsTemplate');
export const getInstanceId = (state: AppState) => getInstanceValue(state, 'instanceId');
export const getHasUserRole = (state: AppState) => getInstanceValue(state, 'hasUserRole', false);
